import { Table } from "@/features/Table";
import { type I1Position, i1_positions_columns } from "./columns";
import { type FilterI1PositionsSchema, FilterI1Positions } from "./filter";

const client = "i1";
const table_name = "i1_positions";

export const I1PositionsTable = () => {
  return (
    <Table<I1Position, FilterI1PositionsSchema>
      label="Positions"
      client={client}
      table_name={table_name}
      columns={i1_positions_columns}
      filter={<FilterI1Positions />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
